function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M242.08137894976352 346.36192050093484 L310.5 304.36490331185223 L386.9403538067381 342.1310679634522",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 354.2170184213643 L82.78111552166845 360.3478676292241",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M112.11108835391065 363.3387579004264 L207 342.9854878389342 L239.2933346953322 346.12533698189253",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 361.2354536127844 L33.185642038016766 367.3324776371379",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M141.86470283536295 374.0269284097584 L207 346.1500712053788 L310.5 365.35129898034853 L316.1747398299136 365.50105787651404",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5 367.5739748458519 L23.106568062308433 370.4951339509354",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M147.02445722350407 376.55439003323926 L207 354.0293339092065 L272.9264855691344 370.922156782457",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M157.8716711024139 382.6490758855568 L207 373.57956304707733 L256.99364572000104 374.25983709137824",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M164.8432089368344 387.19772026303315 L201.76681963444008 394.57018708635337",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M209.76285529204637 394.57062931226926 L310.5 368.8365702244739 L409 341.7343008675655",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5 379.4307941527048 L103.5 361.32283674667383 L179.01807571227997 398.3290929614265",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M23.785626908359585 395.1328748434469 L28.856226417027955 395.8997351127978",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M221.39666035185635 396.71839059193707 L284.61653515843534 402.1014643119702",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M325.69102882858874 396.4046222057449 L409 345.2926879288025",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M28.130682757669884 396.3135223734954 L103.5 375.3145998068799 L171.93144204052197 400.26018322657217",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M362.1620960147223 397.6635842692799 L362.5618385164744 397.62551423256605",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M258.8183289144609 410.9079950441485 L310.5 398.4018276522894 L362.39246633681415 397.69926743866904",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M5 392.3794550763072 L49.97985263592451 404.57725244100743",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M330.7900665541098 416.800325663105 L409 387.1914813810822",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M5 430.4848822778703 L103.5 398.6898332643082 L149.75422395185862 409.0218067939177",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M270.08915839248476 417.99311902831823 L310.5 414.43325709066687 L346.46730080675275 420.908773223034",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M130.36500107388105 420.90939410848125 L207 394.196186870276 L273.5302143738168 420.5083653260525",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M347.39894633634896 420.89755761730606 L409 396.7119942106832",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M5 433.5560921141637 L9.680238611873222 432.95814891049827",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M225.76430814472684 428.64725604744643 L310.5 426.4644963490081 L407.10754376070014 434.97600224180803",
  stroke: "#c3c3c3",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M5 437.55639125876536 L103.5 425.93058424343883 L176.6184841608704 425.35843402755563",
  stroke: "#ff9f1c",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M5 451.67397654080656 L56.68920905904397 436.1580859725833",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M295.88594660765864 441.6637584747576 L310.5 446.1437205917309 L409 437.70606612272053",
  stroke: "#f81735",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M5 459.04000905874966 L103.5 440.1281875161184 L207 432.1956621063 L310.5 450.9142387039957 L409 445.6295648996767",
  stroke: "#41ead5",
  strokeWidth: "1px",
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
});

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 300 414 165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c3a005c1.svg";
export { ForwardRef as ReactComponent };